import React, { useContext } from "react"
import tw from "twin.macro"
import { DisclaimersContext } from "../../../../contexts/Disclaimers"
import { toggleDisclaimersModal } from "../../../../contexts/Disclaimers/actions"
import { LanguageContext } from "../../../../contexts/Language"
import { parseDisclaimerBlocks } from "../../../../helpers"

import { Image } from "../../../atoms/Image"
import { HotspotProps } from "./ModelHighlightsModuleProps.d"

const Hotspot: React.FC<HotspotProps> = ({
  hotspot,
  activeSpot,
  setActiveSpot,
  parentLeft,
  parentRight,
  currentAngle,
  setCurrentAngle,
}) => {
  const { language } = useContext(LanguageContext)
  const [state, dispatch] = useContext(DisclaimersContext)

  return (
    <div
      className="group"
      key={`hotspot-${hotspot?._key}`}
      id={`hotspot-${hotspot?._key}`}
      css={[
        tw`w-auto h-full min-h-[510px] opacity-60 bg-[#E8E4E0] rounded-2xl flex flex-col gap-6 hover:(transition duration-150 ease-in-out opacity-100)`,
        hotspot?._key === activeSpot?._key && tw`opacity-100`,
      ]}
      onClick={() => {
        setActiveSpot(hotspot)
        currentAngle !== hotspot?.angle && setCurrentAngle(hotspot?.angle)
      }}
    >
      <div
        css={[
          tw`relative h-full`,
          hotspot?._key === activeSpot?._key && tw`p-0 opacity-100`,
        ]}
      >
        <Image
          imageData={hotspot?.image}
          role="presentation"
          css={[tw`w-full object-cover rounded-t-2xl max-h-60`]}
        />
        <div
          css={[
            hotspot?.image ? tw`px-10 pt-5 pb-16` : tw`px-10 pt-20 pb-16`,
            tw`flex flex-col gap-6`,
          ]}
        >
          <p css={[tw`text-left text-3xl`]}>
            {language === "es"
              ? parseDisclaimerBlocks(
                  hotspot?.titleES,
                  selection => dispatch(toggleDisclaimersModal(selection)),
                  parentLeft,
                  parentRight,
                )
              : parseDisclaimerBlocks(
                  hotspot?.title,
                  selection => dispatch(toggleDisclaimersModal(selection)),
                  parentLeft,
                  parentRight,
                )}
          </p>
          <p css={[tw`text-left text-xl font-light leading-9`]}>
            {language === "es"
              ? parseDisclaimerBlocks(
                  hotspot?.descriptionES,
                  selection => dispatch(toggleDisclaimersModal(selection)),
                  parentLeft,
                  parentRight,
                )
              : parseDisclaimerBlocks(
                  hotspot?.description,
                  selection => dispatch(toggleDisclaimersModal(selection)),
                  parentLeft,
                  parentRight,
                )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Hotspot
